export default {
  subject: '通知标题',
  notification_time: '通知时间',
  type: '通知类型',
  unread: '未读',
  all: '全部',
  mark_all_read: '全部标记为已读({count})',
  notification_content: '通知内容',
  attachment: '附件',
  view_all: '查看全部',
  no_notification: '您暂时没有通知。'
}
